module.exports = __webpack_public_path__ + "static/media/NikoShaka.90ec4edc.jpg";